import { Datagrid, ListProps, TextField } from 'react-admin';
import { CustomList, MediaField, SortableDatagridBody } from '../../components';
import ActiveField from '../../components/ActiveField';

export default function AwardsList(props: ListProps) {
  return (
    <CustomList 
      {...props} 
      filter={{
        $limit: -1,
        $sort: 'position'
      }}
      pagination={false}
    >
      <Datagrid body={<SortableDatagridBody />} rowClick="edit">
        <MediaField label="Foto" source="photo" sortable={false} />

        <TextField label="Título" source="title" sortable={false} />

        <ActiveField
          label="Destaque"
          source="featured"
          values={['Não', 'Sim']}
          sortable={false} 
        />

        <ActiveField label="Ativo" />
      </Datagrid>
    </CustomList>
  );
}
